import { createAction, props } from "@ngrx/store";
import { ShopActionTypes } from "./action.types";
import { ShopItem } from "src/app/core/models/entites/shop/shopItem";
import { SubmitOrderRequest } from "src/app/core/models/requests/shop/submitOrderRequest";

export const GET_ALL_SHOP_ITEMS = createAction(ShopActionTypes.GetAllShopItems);
export const GET_ALL_SHOP_ITEMS_SUCCESS = createAction(ShopActionTypes.GetAllShopItemsSuccess, props<{ allShopItems: ShopItem[] }>());

export const ADD_SHOP_ITEM_TO_CART = createAction(ShopActionTypes.AddShopItemToCart, props<{ shopItemToAdd: ShopItem, shopItemAmount: number }>());

export const REMOVE_SHOP_ITEM_FROM_CART = createAction(ShopActionTypes.RemoveShopItemFromCart, props<{ shopItemToRemoveIndex: number }>());
export const DECREASE_SHOP_ITEM_AMOUNT = createAction(ShopActionTypes.DecreaseShopItemAmount, props<{ shopItemToRemove: ShopItem }>());

export const SUBMIT_ORDER_REQUEST = createAction(ShopActionTypes.SubmitOrderRequest, props<{ submitOrderRequest: SubmitOrderRequest }>());
export const SUBMIT_ORDER_REQUEST_SUCCESS = createAction(ShopActionTypes.SubmitOrderRequestSuccess, props<{ orderId: string }>());
export const SUBMIT_ORDER_REQUEST_FAILED = createAction(ShopActionTypes.SubmitOrderRequestFailed, props<{ message: string }>());